import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Power4 } from 'gsap/gsap-core';
import NavigationMain from '../Navigation/Main/Navigation.main';
import MenuDropdown from '@templates/Navigation/Menu/Dropdown/Menu.dropdown.js';
import App from '@templates/App/App.js';

gsap.registerPlugin(ScrollTrigger, Power4);

const Header = {
	hideMenuOnscroll: true,
	el: null,
	scrollDirection: 1,

	init() {
		this.el = $('[component="Header"]');
		if (!this.el.length) return;

		this.page = $('[component="Page"]');
		// this.pageHeader = $('[method="renderPageHeader"]');
		// this.fixedColumn = $('[page="fixedLeftColumn"] .scrollable');
		this.navigation = $('[component="Navigation"]');
		this.headerMenu = $('header.menu');
		this.container = this.el.find('[container]');
		this.stickyElements = $('.isSticky');
		this.bind();
		this.bindScroll();

		MenuDropdown.init(this.el);
	},

	bind() {
		$('[component="Page"]').click((evt) => {
			evt.stopPropagation();
			this.el.removeClass('hover');
		});

		this.el.click((evt) => {
			$(evt.currentTarget).addClass('hover');
		});

		if (window.innerWidth < 1000) return;

		this.el.mouseover((evt) => {
			$(evt.currentTarget).addClass('hover');
		});

		this.el.mouseout((evt) => {
			$(evt.currentTarget).removeClass('hover');
		});
	},

	bindScroll() {
		// console.log(this.page)
		ScrollTrigger.create({
			trigger: this.page,
			start: 'top top',
			end: 'bottom bottom',
			scrub: true,
			// markers: true,
			onUpdate: (evt) => {

				if (Math.round(evt.end * evt.progress) > 120) {
					this.el.addClass('scrolled');
					this.headerMenu.addClass('filled');
				} else {
					this.el.removeClass('scrolled');
					this.headerMenu.removeClass('filled');
				}

				if (!this.hideMenuOnscroll) return;

				if ((Math.abs(evt.getVelocity()) > 250) && evt.direction !== this.scrollDirection) {
					if (evt.direction === 1) {
						this.el.addClass('hidden');
						this.headerMenu.addClass('onTop');
						this.navigation.addClass('hidden');
						if(App.isMobile) this.headerMenu.addClass('hidden');
						this.stickyElements.removeClass('scrollUp');
						// this.pageHeader.addClass('onTop');
						// this.fixedColumn.addClass('onTop');
					} else {
						this.el.removeClass('hidden');
						this.headerMenu.removeClass('onTop');
						this.navigation.removeClass('hidden');
						if(App.isMobile) this.headerMenu.removeClass('hidden');
						this.stickyElements.addClass('scrollUp');
						// this.pageHeader.removeClass('onTop');
						// this.fixedColumn.removeClass('onTop');
					}

					this.scrollDirection = evt.direction;
				}
			},
		});
	},

	show() {
		this.el.removeClass('hidden');
	},

	hide() {
		this.el.addClass('hidden');
		console.log(this.el);
	},

	showPermanent() {
		this.el.removeClass('hidden_permanent');
	},

	hidePermanent() {
		this.el.addClass('hidden_permanent');
	},

	destroy() {
		this.el.addClass('destroy');
	},

	open: function() {
		// $('[component="Page"]').attr('menu0pen', '');
		this.el.addClass('open');

		gsap.timeline()
			.to(this.el.find('[block="menu"]'), { y: '0%', duration: 1, ease: Power4.easeOut }, 0)
			.from(this.el.find('[block="menu"] .lang'), { y: '-100%', duration: 2, ease: Power4.easeOut }, 0.4)
			.fromTo(this.el.find('[block="menu"] nav li'),
				{ y: '-100%', opacity: 0 },
				{ y: '0%', opacity: 1, stagger: 0.1, duration: 0.5, overwrite: true, clearProps: true, ease: Power4.easeOut }, 0.3);
	},

	close: function() {
		// $('[component="Page"]').removeAttr('menu0pen');
		this.el.removeClass('open');

		gsap.timeline()
			.to(this.el.find('[block="menu"]'), { y: '-140%', duration: 1, ease: Power4.easeOut }, 0);
	},
};

export default Header;